<div class="toggle__container">
  <label class="toggle__switch" [ngClass]="{ 'active' : switchState, 'disabled' : isDisabled }">
    <input type="checkbox" [disabled]="isDisabled" (change)="switchActivated($event)" /><div></div>
  </label>
</div>
